import { Module } from "vuex";

export const datademo: Module<any, any> = {
  state: {
    datademo: {},
    query: {},
    checkBackList: false,
  },
  getters: {
    datademo: (state) => state.datademo,
    query: (state) => state.query,
    checkBackList: (state) => state.checkBackList,
  },
  mutations: {
    setdatademo(state, data) {
      state.datademo = data;
    },
    setqueryCpn(state, data) {
      state.query = data;
    },
    setcheckBackList(state, data) {
      state.checkBackList = data;
    },
  },
  actions: {
    setdatademo(data) {
      console.log(data);
      data.commit("setdatademo");
    },
    setqueryCpn(query) {
      query.commit("setqueryCpn");
    },
    setcheckBackList(check) {
      check.commit("setcheckBackList");
    },
  },
};
